import { createStart, createMiddleware } from "@tanstack/react-start";
import { attachSupabaseAuth } from "@/integrations/supabase/auth-attacher";

const cspReportOnly = [
  "default-src 'self'",
  "script-src 'self' 'unsafe-inline' 'unsafe-eval' https://cdn.gpteng.co https://static.iyzipay.com https://sandbox-static.iyzipay.com https://www.googletagmanager.com https://accounts.google.com https://apis.google.com",
  "style-src 'self' 'unsafe-inline' https://fonts.googleapis.com",
  "font-src 'self' data: https://fonts.gstatic.com",
  "img-src 'self' data: blob: https:",
  "connect-src 'self' https://*.supabase.co wss://*.supabase.co https://*.lovable.app https://cdn.gpteng.co https://www.google-analytics.com https://accounts.google.com",
  "frame-src 'self' https://*.iyzipay.com https://sandbox-static.iyzipay.com https://accounts.google.com",
  "frame-ancestors 'self' https://*.lovable.app https://lovable.dev",
  "base-uri 'self'",
  "form-action 'self'",
].join("; ");

const securityHeadersMiddleware = createMiddleware().server(async ({ request, next }) => {
  const url = new URL(request.url);
  if (url.pathname.startsWith("/lovable/") || url.pathname === "/email/unsubscribe") {
    return next();
  }
  const result = await next();

  const response = result.response;
  if (response && response.headers) {
    response.headers.set(
      "Strict-Transport-Security",
      "max-age=31536000; includeSubDomains; preload"
    );
    response.headers.set("X-Content-Type-Options", "nosniff");
    response.headers.set("Referrer-Policy", "strict-origin-when-cross-origin");
    response.headers.set(
      "Permissions-Policy",
      "geolocation=(), microphone=(), camera=(self), payment=(self)"
    );
    response.headers.set("Content-Security-Policy-Report-Only", cspReportOnly);
  }

  return result;
});

export const startInstance = createStart(() => ({
  functionMiddleware: [attachSupabaseAuth],
  requestMiddleware: [securityHeadersMiddleware],
}));
